var render = function render() {
  var _vm$itemObj$style, _vm$themeColor;
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    key: _vm.timer1,
    staticClass: "contBox2",
    class: (_vm.pageType === "LANDING_PAGE" || _vm.pageType === "INFORECORD_PAGE") && _vm.itemObj.controlsMark == "bottomButton" ? "btnBox" : ""
  }, [_vm.itemObj.controlsMark == "titleTop" ? _c("title-top", {
    style: _vm.styleInfo,
    attrs: {
      styleObj: _vm.itemObj.style,
      pageDescription: _vm.pageDescription,
      pageDescriptionConfig: _vm.pageDescriptionConfig
    },
    on: {
      itemClick: _vm.itemFun
    }
  }) : _vm._e(), _vm.itemObj.controlsMark == "navigation" ? _c("navigation", {
    style: _vm.styleInfo,
    attrs: {
      styleObj: _vm.itemObj.style,
      fontColor: (_vm$itemObj$style = _vm.itemObj.style) === null || _vm$itemObj$style === void 0 || (_vm$itemObj$style = _vm$itemObj$style.fontColor) === null || _vm$itemObj$style === void 0 ? void 0 : _vm$itemObj$style.split("#")[1]
    },
    on: {
      itemClick: _vm.itemFun
    }
  }, [_vm.itemObj.isClick && _vm.itemIndex > 1 ? _c("operation", {
    attrs: {
      slot: "edit",
      itemIndex: _vm.itemIndex,
      downShow: _vm.downShow,
      upShow: _vm.upShow
    },
    on: {
      delItem: _vm.delItemFun,
      upItem: _vm.upItemFun,
      downItem: _vm.downItemFun
    },
    slot: "edit"
  }) : _vm._e()], 1) : _vm._e(), _vm.itemObj.controlsMark == "mainDrawing" ? _c("mainDrawing", {
    style: _vm.styleInfo,
    attrs: {
      styleObj: _vm.itemObj.style,
      themeColor: _vm.themeColor
    },
    on: {
      itemClick: _vm.itemFun
    }
  }, [_vm.mainDrawingShow ? _c("operation", {
    attrs: {
      slot: "edit",
      itemIndex: _vm.itemIndex,
      downShow: _vm.downShow,
      upShow: _vm.upShow
    },
    on: {
      delItem: _vm.delItemFun,
      upItem: _vm.upItemFun,
      downItem: _vm.downItemFun
    },
    slot: "edit"
  }) : _vm._e()], 1) : _vm._e(), _vm.itemObj.controlsMark == "product" ? _c("product", {
    style: _vm.styleInfo,
    attrs: {
      itemIndex: _vm.itemIndex,
      styleObj: _vm.itemObj.style,
      themeColor: (_vm$themeColor = _vm.themeColor) === null || _vm$themeColor === void 0 ? void 0 : _vm$themeColor.split("#")[1],
      pageType: _vm.pageType
    },
    on: {
      itemClick: _vm.itemFun
    }
  }, [_vm.itemObj.isClick ? _c("operation", {
    attrs: {
      slot: "edit",
      itemIndex: _vm.itemIndex,
      downShow: _vm.downShow,
      upShow: _vm.upShow
    },
    on: {
      delItem: _vm.delItemFun,
      upItem: _vm.upItemFun,
      downItem: _vm.downItemFun
    },
    slot: "edit"
  }) : _vm._e()], 1) : _vm._e(), _vm.itemObj.controlsMark == "clause" ? _c("clause", {
    style: _vm.styleInfo,
    attrs: {
      styleObj: _vm.itemObj.style,
      themeColor: _vm.themeColor,
      pageType: _vm.pageType
    },
    on: {
      itemClick: _vm.itemFun
    }
  }, [_vm.itemObj.isClick ? _c("operation", {
    attrs: {
      slot: "edit",
      itemIndex: _vm.itemIndex,
      downShow: _vm.downShow,
      upShow: _vm.upShow
    },
    on: {
      delItem: _vm.delItemFun,
      upItem: _vm.upItemFun,
      downItem: _vm.downItemFun
    },
    slot: "edit"
  }) : _vm._e()], 1) : _vm._e(), _vm.itemObj.controlsMark == "guarantee" ? _c("guarantee", {
    style: _vm.styleInfo,
    attrs: {
      styleObj: _vm.itemObj.style,
      themeColor: _vm.themeColor,
      pageType: _vm.pageType
    },
    on: {
      itemClick: _vm.itemFun
    }
  }, [_vm.itemObj.isClick ? _c("operation", {
    attrs: {
      slot: "edit",
      itemIndex: _vm.itemIndex,
      downShow: _vm.downShow,
      upShow: _vm.upShow
    },
    on: {
      delItem: _vm.delItemFun,
      upItem: _vm.upItemFun,
      downItem: _vm.downItemFun
    },
    slot: "edit"
  }) : _vm._e()], 1) : _vm._e(), _vm.itemObj.controlsMark == "claims" ? _c("claims", {
    style: _vm.styleInfo,
    attrs: {
      styleObj: _vm.itemObj.style,
      themeColor: _vm.themeColor,
      pageType: _vm.pageType
    },
    on: {
      itemClick: _vm.itemFun
    }
  }, [_vm.itemObj.isClick ? _c("operation", {
    attrs: {
      slot: "edit",
      itemIndex: _vm.itemIndex,
      downShow: _vm.downShow,
      upShow: _vm.upShow
    },
    on: {
      delItem: _vm.delItemFun,
      upItem: _vm.upItemFun,
      downItem: _vm.downItemFun
    },
    slot: "edit"
  }) : _vm._e()], 1) : _vm._e(), _vm.itemObj.controlsMark == "information" ? _c("information", {
    style: _vm.styleInfo,
    attrs: {
      styleObj: _vm.itemObj.style,
      themeColor: _vm.themeColor,
      pageType: _vm.pageType
    },
    on: {
      itemClick: _vm.itemFun
    }
  }, [_vm.itemObj.isClick ? _c("operation", {
    attrs: {
      slot: "edit",
      itemIndex: _vm.itemIndex,
      downShow: _vm.downShow,
      upShow: _vm.upShow
    },
    on: {
      delItem: _vm.delItemFun,
      upItem: _vm.upItemFun,
      downItem: _vm.downItemFun
    },
    slot: "edit"
  }) : _vm._e()], 1) : _vm._e(), _vm.itemObj.controlsMark == "bottomButton" ? _c("bottom-button", {
    style: _vm.styleInfo,
    attrs: {
      styleObj: _vm.itemObj.style,
      themeColor: _vm.themeColor,
      pageDescription: _vm.pageDescription,
      pageDescriptionConfig: _vm.pageDescriptionConfig,
      itemIndex: _vm.itemIndex,
      arrNum: _vm.arrNum
    },
    on: {
      itemClick: _vm.itemFun,
      premiumlick: _vm.premiumlickFun,
      buttonModalClick: _vm.buttonModalClickFun
    }
  }, [_vm.itemObj.isClick ? _c("operation", {
    attrs: {
      slot: "edit",
      itemIndex: _vm.itemIndex,
      downShow: _vm.downShow,
      upShow: _vm.upShow
    },
    on: {
      delItem: _vm.delItemFun,
      upItem: _vm.upItemFun,
      downItem: _vm.downItemFun
    },
    slot: "edit"
  }) : _vm._e()], 1) : _vm._e(), _vm.itemObj.controlsMark == "informationConfirmation" ? _c("information-confirmation", {
    style: _vm.styleInfo,
    attrs: {
      styleObj: _vm.itemObj.style,
      themeColor: _vm.themeColor
    },
    on: {
      itemClick: _vm.itemFun
    }
  }, [_vm.itemObj.isClick ? _c("operation", {
    attrs: {
      slot: "edit",
      itemIndex: _vm.itemIndex,
      downShow: _vm.downShow,
      upShow: _vm.upShow
    },
    on: {
      delItem: _vm.delItemFun,
      upItem: _vm.upItemFun,
      downItem: _vm.downItemFun
    },
    slot: "edit"
  }) : _vm._e()], 1) : _vm._e(), _vm.itemObj.controlsMark == "trial" ? _c("trial", {
    style: _vm.styleInfo,
    attrs: {
      styleObj: _vm.itemObj.style,
      themeColor: _vm.themeColor
    },
    on: {
      itemClick: _vm.itemFun
    }
  }, [_vm.itemObj.isClick ? _c("operation", {
    attrs: {
      slot: "edit",
      itemIndex: _vm.itemIndex,
      downShow: _vm.downShow,
      upShow: _vm.upShow
    },
    on: {
      delItem: _vm.delItemFun,
      upItem: _vm.upItemFun,
      downItem: _vm.downItemFun
    },
    slot: "edit"
  }) : _vm._e()], 1) : _vm._e(), _vm.itemObj.controlsMark == "inform" ? _c("inform", {
    style: _vm.styleInfo,
    attrs: {
      styleObj: _vm.itemObj.style
    },
    on: {
      itemClick: _vm.itemFun
    }
  }, [_vm.itemObj.isClick ? _c("operation", {
    attrs: {
      slot: "edit",
      itemIndex: _vm.itemIndex,
      downShow: _vm.downShow,
      upShow: _vm.upShow
    },
    on: {
      delItem: _vm.delItemFun,
      upItem: _vm.upItemFun,
      downItem: _vm.downItemFun
    },
    slot: "edit"
  }) : _vm._e()], 1) : _vm._e(), _vm.itemObj.controlsMark == "disclosureIcp" ? _c("disclosureIcp", {
    style: _vm.styleInfo,
    attrs: {
      styleObj: _vm.itemObj.style
    },
    on: {
      itemClick: _vm.itemFun
    }
  }, [_vm.itemObj.isClick ? _c("operation", {
    attrs: {
      slot: "edit",
      itemIndex: _vm.itemIndex,
      downShow: _vm.downShow,
      upShow: _vm.upShow
    },
    on: {
      delItem: _vm.delItemFun,
      upItem: _vm.upItemFun,
      downItem: _vm.downItemFun
    },
    slot: "edit"
  }) : _vm._e()], 1) : _vm._e(), _vm.itemObj.controlsMark == "productList" ? _c("productList", {
    style: _vm.styleInfo,
    attrs: {
      styleObj: _vm.itemObj.style,
      themeColor: _vm.themeColor,
      pageType: _vm.pageType
    },
    on: {
      itemClick: _vm.itemFun
    }
  }, [_vm.itemObj.isClick ? _c("operation", {
    attrs: {
      slot: "edit",
      itemIndex: _vm.itemIndex,
      downShow: _vm.downShow,
      upShow: _vm.upShow
    },
    on: {
      delItem: _vm.delItemFun,
      upItem: _vm.upItemFun,
      downItem: _vm.downItemFun
    },
    slot: "edit"
  }) : _vm._e()], 1) : _vm._e(), _vm.itemObj.controlsMark == "queryInfo" ? _c("queryInfo", {
    style: _vm.styleInfo,
    attrs: {
      styleObj: _vm.itemObj.style,
      themeColor: _vm.themeColor,
      pageType: _vm.pageType
    },
    on: {
      itemClick: _vm.itemFun
    }
  }, [_vm.itemObj.isClick ? _c("operation", {
    attrs: {
      slot: "edit",
      itemIndex: _vm.itemIndex,
      downShow: _vm.downShow,
      upShow: _vm.upShow
    },
    on: {
      delItem: _vm.delItemFun,
      upItem: _vm.upItemFun,
      downItem: _vm.downItemFun
    },
    slot: "edit"
  }) : _vm._e()], 1) : _vm._e(), _vm.itemObj.controlsMark == "policyCancel" ? _c("policyCancel", {
    style: _vm.styleInfo,
    attrs: {
      styleObj: _vm.itemObj.style,
      themeColor: _vm.themeColor,
      pageType: _vm.pageType
    },
    on: {
      itemClick: _vm.itemFun
    }
  }, [_vm.itemObj.isClick ? _c("operation", {
    attrs: {
      slot: "edit",
      itemIndex: _vm.itemIndex,
      downShow: _vm.downShow,
      upShow: _vm.upShow
    },
    on: {
      delItem: _vm.delItemFun,
      upItem: _vm.upItemFun,
      downItem: _vm.downItemFun
    },
    slot: "edit"
  }) : _vm._e()], 1) : _vm._e(), _vm.itemObj.controlsMark == "policyDetail" ? _c("policyDetail", {
    style: _vm.styleInfo,
    attrs: {
      styleObj: _vm.itemObj.style,
      themeColor: _vm.themeColor,
      pageType: _vm.pageType
    },
    on: {
      itemClick: _vm.itemFun
    }
  }, [_vm.itemObj.isClick ? _c("operation", {
    attrs: {
      slot: "edit",
      itemIndex: _vm.itemIndex,
      downShow: _vm.downShow,
      upShow: _vm.upShow
    },
    on: {
      delItem: _vm.delItemFun,
      upItem: _vm.upItemFun,
      downItem: _vm.downItemFun
    },
    slot: "edit"
  }) : _vm._e()], 1) : _vm._e(), _vm.itemObj.controlsMark == "invoiceList" ? _c("invoiceList", {
    style: _vm.styleInfo,
    attrs: {
      styleObj: _vm.itemObj.style,
      themeColor: _vm.themeColor,
      pageType: _vm.pageType
    },
    on: {
      itemClick: _vm.itemFun
    }
  }, [_vm.itemObj.isClick ? _c("operation", {
    attrs: {
      slot: "edit",
      itemIndex: _vm.itemIndex,
      downShow: _vm.downShow,
      upShow: _vm.upShow
    },
    on: {
      delItem: _vm.delItemFun,
      upItem: _vm.upItemFun,
      downItem: _vm.downItemFun
    },
    slot: "edit"
  }) : _vm._e()], 1) : _vm._e(), _vm.itemObj.controlsMark == "invoice" ? _c("invoice", {
    style: _vm.styleInfo,
    attrs: {
      styleObj: _vm.itemObj.style,
      themeColor: _vm.themeColor,
      pageType: _vm.pageType
    },
    on: {
      itemClick: _vm.itemFun
    }
  }, [_vm.itemObj.isClick ? _c("operation", {
    attrs: {
      slot: "edit",
      itemIndex: _vm.itemIndex,
      downShow: _vm.downShow,
      upShow: _vm.upShow
    },
    on: {
      delItem: _vm.delItemFun,
      upItem: _vm.upItemFun,
      downItem: _vm.downItemFun
    },
    slot: "edit"
  }) : _vm._e()], 1) : _vm._e(), _vm.itemObj.controlsMark == "invoiceRecordList" ? _c("invoiceRecordList", {
    style: _vm.styleInfo,
    attrs: {
      styleObj: _vm.itemObj.style,
      themeColor: _vm.themeColor,
      pageType: _vm.pageType
    },
    on: {
      itemClick: _vm.itemFun
    }
  }, [_vm.itemObj.isClick ? _c("operation", {
    attrs: {
      slot: "edit",
      itemIndex: _vm.itemIndex,
      downShow: _vm.downShow,
      upShow: _vm.upShow
    },
    on: {
      delItem: _vm.delItemFun,
      upItem: _vm.upItemFun,
      downItem: _vm.downItemFun
    },
    slot: "edit"
  }) : _vm._e()], 1) : _vm._e(), _vm.itemObj.controlsMark == "invoiceDetail" ? _c("invoiceDetail", {
    style: _vm.styleInfo,
    attrs: {
      styleObj: _vm.itemObj.style,
      themeColor: _vm.themeColor,
      pageType: _vm.pageType
    },
    on: {
      itemClick: _vm.itemFun
    }
  }, [_vm.itemObj.isClick ? _c("operation", {
    attrs: {
      slot: "edit",
      itemIndex: _vm.itemIndex,
      downShow: _vm.downShow,
      upShow: _vm.upShow
    },
    on: {
      delItem: _vm.delItemFun,
      upItem: _vm.upItemFun,
      downItem: _vm.downItemFun
    },
    slot: "edit"
  }) : _vm._e()], 1) : _vm._e()], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };